export default {
  valueType: "checkbox",
  FormItemProps: {
    label: '复选框',
    rules: [],
    style: {}
  },
  ControlProps: {
    options: [
      { label: "选项一", value: "1" },
      { label: "选项二", value: "2" }
    ],
  },
}

